var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState, } from 'react';
import classNames from 'classnames';
import SelectMultipleOption from './SelectMultipleOption';
var SelectMultiple = function (props) {
    var className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, hidden = props.hidden, id = props.id, name = props.name, onChange = props.onChange, options = props.options, reset = props.reset, roleDescription = props.roleDescription, defaultLabel = props.defaultLabel, multilineOptions = props.multilineOptions, isSearchable = props.isSearchable, showSelectAll = props.showSelectAll, dataTestValue = props.dataTestValue;
    var processDefaultValues = useCallback(function (option) {
        if (defaultValue && defaultValue.includes(option.value)) {
            return __assign(__assign({}, option), { selected: true });
        }
        return option;
    }, [defaultValue]);
    var _a = useState(options.map(processDefaultValues)), internalOptions = _a[0], setInternalOptions = _a[1];
    var _b = useState(options), filteredOptions = _b[0], setFilteredOptions = _b[1];
    var _c = useState(''), searchValue = _c[0], setSearchValue = _c[1];
    useEffect(function () {
        if (reset) {
            setInternalOptions(options.map(processDefaultValues));
            setSearchValue('');
        }
    }, [reset, options, processDefaultValues]);
    var _optionHandler = function (e, option, idx) {
        if (!hidden && e.key === 'ArrowUp' && e.target.previousSibling) {
            // Moves up one option in open select menu
            e.target.previousSibling.focus();
            return;
        }
        if (!hidden && e.key === 'ArrowDown' && e.target.nextSibling) {
            // Moves down one option in open select menu
            e.target.nextSibling.focus();
            return;
        }
        if (!disabled && !hidden) {
            if (e.type === 'click' || e.key === ' ' || e.key === 'Enter') {
                if (option.disabled) {
                    return;
                }
                // Manipulates and updates internal options with new selected boolean
                var newInternalOptions = __spreadArray([], internalOptions, true);
                if (option.value === 'selectAll') {
                    newInternalOptions = newInternalOptions.map(function (opt) { return (__assign(__assign({}, opt), { selected: !opt.disabled && !option.selected })); });
                }
                else {
                    newInternalOptions[idx].selected = !internalOptions[idx].selected;
                }
                setInternalOptions(newInternalOptions);
                if (onChange && typeof onChange === 'function') {
                    // Passes event to external change handler if one exists
                    var processedEvent = __assign({}, e);
                    processedEvent.target.name = name;
                    processedEvent.target.value = option.value;
                    processedEvent.target.values = newInternalOptions.reduce(function (values, processedOption) {
                        // This reduce acts as a filter that only adds option.value to the values array
                        if (processedOption.selected) {
                            values.push(processedOption.value);
                        }
                        return values;
                    }, []);
                    onChange(processedEvent);
                }
            }
        }
    };
    var _selectName = classNames('clyde-select clyde-select-multiple', className, {
        'clyde-select--disabled': disabled,
        'clyde-select--hidden': hidden,
    });
    useEffect(function () {
        if (isSearchable && searchValue) {
            var filterRegEx_1 = new RegExp(searchValue, 'i');
            return setFilteredOptions(internalOptions.filter(function (_a) {
                var text = _a.text;
                return (filterRegEx_1.test(text));
            }));
        }
        return setFilteredOptions(internalOptions);
    }, [internalOptions, searchValue]);
    var allSelected = !filteredOptions.some(function (option) { return !option.selected && !option.disabled; });
    var selectAllOption = { text: 'Select All', value: 'selectAll', selected: allSelected };
    return (React.createElement("div", { "aria-disabled": disabled, "aria-hidden": hidden, "aria-multiselectable": true, "aria-roledescription": roleDescription, className: _selectName, id: id, "data-test": dataTestValue, role: 'listbox', tabIndex: 0 },
        React.createElement("div", { className: 'clyde-select-multiple__options-list' },
            isSearchable && React.createElement("div", { className: 'clyde-select__input' },
                React.createElement("input", { placeholder: "Search", className: 'clyde-select__input', value: searchValue, onChange: function (e) { return setSearchValue(e.currentTarget.value); } })),
            defaultLabel
                && React.createElement("div", { className: 'clyde-select-multiple-option clyde-select-multiple-option--label', "data-test": 'selectOptionsArea' },
                    React.createElement("span", { className: 'clyde-select-multiple-option__text' }, defaultLabel)),
            showSelectAll && filteredOptions.length > 1
                && React.createElement(SelectMultipleOption, { key: 'so-select-all-options', option: selectAllOption, selected: selectAllOption.selected, multilineOptions: multilineOptions, _optionHandler: function (e) { return _optionHandler(e, selectAllOption, 0); } }),
            filteredOptions.map(function (option, idx) { return (React.createElement(SelectMultipleOption, { key: "so-".concat(idx), option: option, selected: option.selected, multilineOptions: multilineOptions, _optionHandler: function (e, handlerOption) { _optionHandler(e, handlerOption, idx); } })); }))));
};
export default SelectMultiple;
